module.exports = __webpack_public_path__ + "static/media/invite-friend.dcec361e.png";